import { get } from "./common/dataFetch";

/*export async function oktaConfigAsync() {
    const cfg = await appConfigAsync();

    if (!cfg || !cfg.OktaWidget) {
        console.error("OktaWidget config is missing!", cfg);
        throw new Error("OktaWidget configuration not found");
    }

    return cfg.OktaWidget;
}*/

export async function appConfigAsync() {
    const response = await get("api/config");
    const cfg = response.parsedBody as any;
    return cfg;
};